import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CuttingModalComponent } from '../cutting-modal/cutting-modal.component';

@Component({
  selector: 'py-cutting-wrapper',
  templateUrl: './cutting-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, CuttingModalComponent],
})
export class CuttingWrapperComponent {
  constructor() {}
}
